import type { BasePageConfig } from '@/pageConfig/BasePageConfig';
import ogImage from '@/static/assets/home/og-de.png';

export const config: BasePageConfig = {
  seo: {
    title: 'Lemonade Hausrat- & Privathaftpflichtversicherung | Schütz die Sachen, die du liebst',
    metaTitle: 'Lemonade Hausrat- & Privathaftpflichtversicherung | Schütz die Sachen, die du liebst',
    description:
      'Lemonade bietet Privathaftplicht- & Hausratversicherungen, die von Technologie und sozialem Engagement angetrieben werden. ❤ Wir versprechen Null-Papierkram und alles im Nu, indem wir Makler und Bürokratie durch Bots und Machine Learning ersetzen. Hol dir eine Lemonade Versicherung in Sekundenschnelle, ab 2 €/Monat.',
    ogImage: ogImage.src,
  },
  layout: {
    headerActions: {
      dropdown: {
        logout: 'Ausloggen',
        myAccount: 'Mein Account',
        settings: 'Einstellungen',
      },
      CTAs: {
        backToYourQuote: {
          long: {
            singular: 'Zurück zu deinem Angebot',
            plural: 'Zurück zu deinen Angeboten',
          },
          short: {
            singular: 'ANGEBOT',
            plural: 'ANGEBOT',
          },
        },
        checkOurPrices: {
          long: {
            singular: 'Check unsere preise',
            plural: 'Check unsere preise',
          },
          short: {
            singular: 'Preise',
            plural: 'Preise',
          },
        },
      },
    },
  },
};
